export default __webpack_public_path__ + "static/media/food-plan-eng.30c45355.png";